var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDmFilterMapL(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 170.1 170.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .dummy-widget-filter-map-dm-cls-1 {\n        fill: #58bcb7;\n      }\n\n      .dummy-widget-filter-map-dm-cls-1, .dummy-widget-filter-map-dm-cls-2, .dummy-widget-filter-map-dm-cls-3, .dummy-widget-filter-map-dm-cls-4, .dummy-widget-filter-map-dm-cls-5, .dummy-widget-filter-map-dm-cls-6, .dummy-widget-filter-map-dm-cls-7, .dummy-widget-filter-map-dm-cls-8, .dummy-widget-filter-map-dm-cls-9, .dummy-widget-filter-map-dm-cls-10, .dummy-widget-filter-map-dm-cls-11, .dummy-widget-filter-map-dm-cls-12, .dummy-widget-filter-map-dm-cls-13, .dummy-widget-filter-map-dm-cls-14 {\n        stroke-width: 0px;\n      }\n\n      .dummy-widget-filter-map-dm-cls-2 {\n        fill: #c1c1c1;\n      }\n\n      .dummy-widget-filter-map-dm-cls-15 {\n        clip-path: url(#dummy-widget-filter-map-dm-clippath);\n      }\n\n      .dummy-widget-filter-map-dm-cls-3 {\n        fill: none;\n      }\n\n      .dummy-widget-filter-map-dm-cls-4 {\n        fill: #4eb062;\n      }\n\n      .dummy-widget-filter-map-dm-cls-5 {\n        fill: #e9e9ea;\n      }\n\n      .dummy-widget-filter-map-dm-cls-6 {\n        isolation: isolate;\n        opacity: .5;\n      }\n\n      .dummy-widget-filter-map-dm-cls-6, .dummy-widget-filter-map-dm-cls-13 {\n        fill: #fff;\n      }\n\n      .dummy-widget-filter-map-dm-cls-16 {\n        clip-path: url(#dummy-widget-filter-map-dm-clippath-1);\n      }\n\n      .dummy-widget-filter-map-dm-cls-7 {\n        fill: #9161a4;\n      }\n\n      .dummy-widget-filter-map-dm-cls-8 {\n        fill: #f29c3f;\n      }\n\n      .dummy-widget-filter-map-dm-cls-9 {\n        fill: #e6e6e4;\n      }\n\n      .dummy-widget-filter-map-dm-cls-10 {\n        fill: #49beed;\n      }\n\n      .dummy-widget-filter-map-dm-cls-11 {\n        fill: #3463ac;\n      }\n\n      .dummy-widget-filter-map-dm-cls-12 {\n        fill: #f4f3f3;\n      }\n\n      .dummy-widget-filter-map-dm-cls-14 {\n        fill: #dadada;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "dummy-widget-filter-map-dm-clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-3",
    x: 7.6,
    y: 7.6,
    width: 155.2,
    height: 155.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dummy-widget-filter-map-dm-clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-3",
    x: 11.6,
    y: 41.3,
    width: 94.6,
    height: 91.1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-5",
    y: 0,
    width: 170.1,
    height: 170.1,
    rx: 7.6,
    ry: 7.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-filter-map-dm-cls-15"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-13",
    x: 8,
    y: 33.5,
    width: 154.4,
    height: 103.3,
    rx: 6.2,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-filter-map-dm-cls-2",
    d: "M155.6,136.9H14.8c-3.9,0-7.1-3.2-7.1-7.1V40.3c0-3.9,3.2-7.1,7.1-7.1h140.7c3.9,0,7.1,3.2,7.1,7.1v89.5c0,3.9-3.2,7.1-7.1,7.1h.1ZM14.8,33.7c-3.7,0-6.6,3-6.6,6.6v89.5c0,3.7,3,6.6,6.6,6.6h140.7c3.7,0,6.6-3,6.6-6.6V40.3c0-3.7-3-6.6-6.6-6.6H14.8Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-6",
    x: 8,
    y: -82.8,
    width: 154.4,
    height: 103.3,
    rx: 6.2,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-6",
    x: 7.8,
    y: 150,
    width: 154.8,
    height: 103.3,
    rx: 6.2,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-filter-map-dm-cls-16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-12",
    x: 15.6,
    y: 41.3,
    width: 139.8,
    height: 87.6,
    rx: 6.2,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-14",
    x: 15.6,
    y: 97.3,
    width: 139.8,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-13",
    x: 27,
    y: 41.3,
    width: 5.5,
    height: 56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-13",
    x: 56.1,
    y: 41.3,
    width: 5.5,
    height: 56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-13",
    x: 71.1,
    y: 41.3,
    width: 5.5,
    height: 32.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-13",
    x: 128.6,
    y: 41.3,
    width: 5.5,
    height: 46.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-13",
    x: 56.8,
    y: 70.5,
    width: 34.1,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-13",
    x: 27.3,
    y: 111.8,
    width: 34.1,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-13",
    x: 85.1,
    y: 41.3,
    width: 5.5,
    height: 56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-13",
    x: 114.1,
    y: 41.3,
    width: 5.5,
    height: 56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-13",
    x: 143.2,
    y: 41.3,
    width: 5.5,
    height: 56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-13",
    x: 27,
    y: 104.6,
    width: 5.5,
    height: 24.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-13",
    x: 56.1,
    y: 104.6,
    width: 5.5,
    height: 24.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-13",
    x: 85.1,
    y: 104.6,
    width: 5.5,
    height: 24.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-13",
    x: 114.1,
    y: 104.6,
    width: 5.5,
    height: 24.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-13",
    x: 143.2,
    y: 104.6,
    width: 5.5,
    height: 24.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-filter-map-dm-cls-8",
    cx: 85.6,
    cy: 68.7,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-filter-map-dm-cls-1",
    cx: 93.1,
    cy: 104.6,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-filter-map-dm-cls-8",
    cx: 61.3,
    cy: 95.8,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-filter-map-dm-cls-8",
    cx: 26.2,
    cy: 51.9,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-filter-map-dm-cls-4",
    cx: 26.2,
    cy: 114.4,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-filter-map-dm-cls-4",
    cx: 70,
    cy: 54.1,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-filter-map-dm-cls-1",
    cx: 92,
    cy: 42,
    r: 3.8
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-9",
    x: 112.5,
    y: 40.7,
    width: 44.3,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-filter-map-dm-cls-8",
    cx: 115.7,
    cy: 64.9,
    r: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-9",
    x: 118.6,
    y: 62.6,
    width: 28.7,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-9",
    x: 151.8,
    y: 62.4,
    width: 4.4,
    height: 4.4,
    rx: 1.3,
    ry: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-filter-map-dm-cls-10",
    cx: 115.7,
    cy: 76.5,
    r: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-9",
    x: 118.6,
    y: 74.4,
    width: 28.7,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-filter-map-dm-cls-9",
    d: "M154.9,79.3h-1.6c-1.1,0-2-.9-2-2v-1.6c0-1.1.9-2,2-2h1.6c1.1,0,2,.9,2,2v1.6c0,1.1-.9,2-2,2ZM153.3,74.9c-.5,0-.9.4-.9.9v1.6c0,.5.4.9.9.9h1.6c.5,0,.9-.4.9-.9v-1.6c0-.5-.4-.9-.9-.9h-1.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-filter-map-dm-cls-4",
    cx: 115.7,
    cy: 88.3,
    r: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-9",
    x: 118.6,
    y: 86.1,
    width: 28.7,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-9",
    x: 151.8,
    y: 86.1,
    width: 4.4,
    height: 4.4,
    rx: 1.3,
    ry: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "dummy-widget-filter-map-dm-cls-11",
    cx: 115.6,
    cy: 100,
    rx: 2.1,
    ry: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-9",
    x: 119.3,
    y: 97.8,
    width: 27.8,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-filter-map-dm-cls-9",
    d: "M154.9,102.8h-1.6c-1.1,0-2-.9-2-2v-1.6c0-1.1.9-2,2-2h1.6c1.1,0,2,.9,2,2v1.6c0,1.1-.9,2-2,2ZM153.3,98.4c-.5,0-.9.4-.9.9v1.6c0,.5.4.9.9.9h1.6c.5,0,.9-.4.9-.9v-1.6c0-.5-.4-.9-.9-.9h-1.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-filter-map-dm-cls-7",
    cx: 115.7,
    cy: 111.7,
    r: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-9",
    x: 119.7,
    y: 109.5,
    width: 27.6,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-filter-map-dm-cls-9",
    d: "M154.8,114.2h-1.6c-1.1,0-2-.9-2-2v-1.6c0-1.1.9-2,2-2h1.6c1.1,0,2,.9,2,2v1.6c0,1.1-.9,2-2,2ZM153.3,109.8c-.5,0-.9.4-.9.9v1.6c0,.5.4.9.9.9h1.6c.5,0,.9-.4.9-.9v-1.6c0-.5-.4-.9-.9-.9h-1.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-filter-map-dm-cls-1",
    cx: 115.7,
    cy: 123.5,
    r: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-9",
    x: 119.7,
    y: 121.3,
    width: 27.9,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-filter-map-dm-cls-9",
    x: 151.9,
    y: 121.3,
    width: 4.4,
    height: 4.4,
    rx: 1.3,
    ry: 1.3
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmFilterMapL);
export default __webpack_public_path__ + "static/media/dm_filter_map_l.f9c54456.svg";
export { ForwardRef as ReactComponent };